import React, { PureComponent, Fragment } from "react";
import { Row, Col, Divider, Form, Button, Icon } from "antd";
import moment from "moment";
import PhoneNumberMask from "../../../../../../common/inputs/AuthorizationInputs";

import "./forms.css";

import {
  SubjectId,
  RequestId,
  Customer,
  Inn,
  PhoneCode,
  // PhoneNumber,
  Email,
  PassengersCount,
  StartPoint,
  ArrivalDate,
  ArrivalTime,
  Comment,
  EndPoint,
  Maintenance,
  // UsingTime,
  ServiceType,
  KidsCount,
  AccompCount,
  LastName,
  Name,
  Patronymic,
  WorkersCount,
  MedWorkersCount
} from "./fieldsConfig";

import RouteMidPoint from "./routeMidPoint";
import ReactToPrint from "react-to-print";

function EqualToStart(start, end) {
  let str = "";
  if (end.includes(start)) {
    str = "Совпадает с местом подачи";
  }

  return str;
}

class FastForm extends PureComponent {
  renderMidPoints(array) {
    let { getFieldDecorator } = this.props.form;
    let midPoints = array.slice(1, array.length - 1);

    return midPoints.map((point, index) => (
      <RouteMidPoint
        key={point.routeId}
        decorator={getFieldDecorator}
        number={index + 1}
        address={point.route}
        time={point.duration}
      />
    ));
  }

  render() {
    const { request, form, showDrawer, componentRef } = this.props;
    const { getFieldDecorator } = form;
    const company = request.profileId ? request.profileId.companyId : null;
    // const dateNow = new Date().getTime();
    // const dateArrival = new Date(moment(request.arrivalDatetime)).getTime();
    // const days = Math.ceil(
    //   Math.abs(dateArrival - dateNow) / (1000 * 3600 * 24)
    // );

    return (
      <div className="requestCardForm">
        <Form>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Номер заявки:</span>
            </Col>
            <Col span={12} className="formCol">
              <RequestId
                val={request.number ? request.number : "не указана"}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
            <Col span={6} className="formCol extra-label">
              <ReactToPrint
                content={() => componentRef}
                bodyClass={"requestCardForm"}
                trigger={() => {
                  return (
                    <Button type="link" className="withIcon">
                      Распечатать
                      <Icon type="printer" />
                    </Button>
                  );
                }}
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Субъект заказчика:</span>
            </Col>
            <Col span={12} className="formCol">
              <SubjectId
                val={
                  !company
                    ? "Не указано"
                    : company.subjectId &&
                      company.subjectId.subjectKey === "individ"
                    ? company.subjectId.subjectAbbr
                    : company.subjectId && company.subjectId.subject
                }
                decorator={getFieldDecorator}
                classes="middle"
                disabled
              />
            </Col>
            <Col span={6} className="formCol">
              <Button
                id={
                  company &&
                  company.subjectId &&
                  company.subjectId.subjectKey === "individ"
                    ? "requisitesIndivid"
                    : company.subjectId.subjectKey === "physical"
                    ? "requisitesPhysical"
                    : company.subjectId.subjectKey === "legal"
                    ? "requisitesLegal"
                    : null
                }
                onClick={e => showDrawer(e)}
                block
                className="btn extra-label"
              >
                Подробнее
              </Button>
            </Col>
          </Row>
          {!company ? null : company.subjectId.subjectKey === "physical" ? (
            <Fragment>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">Фамилия:</span>
                </Col>
                <Col span={12} className="formCol">
                  <LastName
                    val={company.lastname}
                    decorator={getFieldDecorator}
                    classes="short"
                    disabled
                  />
                </Col>
              </Row>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">Имя:</span>
                </Col>
                <Col span={12} className="formCol">
                  <Name
                    val={company.name}
                    decorator={getFieldDecorator}
                    classes="short"
                    disabled
                  />
                </Col>
              </Row>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">Отчество:</span>
                </Col>
                <Col span={12} className="formCol">
                  <Patronymic
                    val={company.patronymic}
                    decorator={getFieldDecorator}
                    classes="short"
                    disabled
                  />
                </Col>
              </Row>
            </Fragment>
          ) : (
            <Fragment>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">Заказчик:</span>
                </Col>
                <Col span={12} className="formCol">
                  <Customer
                    val={company.nameLegal}
                    decorator={getFieldDecorator}
                    classes="long"
                    disabled
                  />
                </Col>
              </Row>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">ИНН:</span>
                </Col>
                <Col span={12} className="formCol">
                  <Inn
                    val={company.inn}
                    decorator={getFieldDecorator}
                    classes="long"
                    disabled
                  />
                </Col>
              </Row>
            </Fragment>
          )}
          <Divider />
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Номер телефона:</span>
            </Col>
            <Col span={12} className="formCol">
              <Col span={12} className="formCol" style={{ paddingLeft: "0" }}>
                <PhoneCode
                  val={request.profileId ? request.profileId.phoneCode : null}
                  // val={!company ? null : company.phoneCode}
                  decorator={getFieldDecorator}
                  classes="small mr"
                  disabled
                />
                {/*<PhoneNumber
                  val={!company ? 'Не указано' : company.phone}
                  decorator={getFieldDecorator}
                  classes="short"
                  mask="(###) ###-##-##"
                  disabled
                />*/}
                <PhoneNumberMask
                  autoComplete="off"
                  className="short"
                  name="phone"
                  mask="(###) ###-##-##"
                  value={
                    request.profileId
                      ? request.profileId.phoneNumber
                      : "undefined"
                  }
                  // value={company && company.phone ? company.phone : ''}
                  maxLength={15}
                  disabled
                />
              </Col>
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">E-mail:</span>
            </Col>
            <Col span={12} className="formCol">
              <Email
                val={request.profileId ? request.profileId.email : "Не указан"}
                // val={company && company.email ? company.email : 'Не указан'}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          <Divider />
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Вид транспортной услуги:</span>
            </Col>
            <Col span={12} className="formCol">
              <ServiceType
                val={
                  request.serviceTypeId
                    ? request.serviceTypeId.serviceType
                    : null
                }
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          {request.serviceTypeId &&
          request.serviceTypeId.serviceTypeKey === "kids" ? (
            <Fragment>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                {+request.kidsCount > 0 && (
                  <>
                    <Col span={6} className="formCol right">
                      <span className="label">
                        Максимальное&nbsp;количество детей:
                      </span>
                    </Col>
                    <Col span={3} className="formCol">
                      <KidsCount
                        val={
                          request.kidsCount !== null ? request.kidsCount : "0"
                        }
                        decorator={getFieldDecorator}
                        classes="small mr"
                        disabled
                      />
                    </Col>
                  </>
                )}
                {+request.passengersCount > 0 && (
                  <Col span={9} className="formCol">
                    <span className="label">
                      Общее число пассажиров: {request.passengersCount}
                    </span>
                  </Col>
                )}
              </Row>
              {+request.accompCount > 0 && (
                <Row type="flex" align="middle" className="formRow" gutter={16}>
                  <Col span={6} className="formCol right">
                    <span className="label">
                      Максимальное&nbsp;количество сопровождающих:
                    </span>
                  </Col>
                  <Col span={12} className="formCol">
                    <AccompCount
                      val={
                        request.accompCount !== null ? request.accompCount : "0"
                      }
                      decorator={getFieldDecorator}
                      classes="small mr"
                      disabled
                    />
                  </Col>
                </Row>
              )}
              {+request.workersCount > 0 && (
                <Row type="flex" align="middle" className="formRow" gutter={16}>
                  <Col span={6} className="formCol right">
                    <span className="label">
                      Макс. количество работников и&nbsp;(или) физ. лиц,
                      участвующих в перевозке:
                    </span>
                  </Col>
                  <Col span={12} className="formCol">
                    <WorkersCount
                      val={
                        request.workersCount !== null
                          ? request.workersCount
                          : "0"
                      }
                      decorator={getFieldDecorator}
                      classes="small mr"
                      disabled
                    />
                  </Col>
                </Row>
              )}
              {+request.medWorkersCount > 0 && (
                <Row type="flex" align="middle" className="formRow" gutter={16}>
                  <Col span={6} className="formCol right">
                    <span className="label">
                      Максимальное количество мед. работников:
                    </span>
                  </Col>
                  <Col span={12} className="formCol">
                    <MedWorkersCount
                      val={
                        request.medWorkersCount !== null
                          ? request.medWorkersCount
                          : "0"
                      }
                      decorator={getFieldDecorator}
                      classes="small mr"
                      disabled
                    />
                  </Col>
                </Row>
              )}
            </Fragment>
          ) : (
            <Row type="flex" align="middle" className="formRow" gutter={16}>
              <Col span={6} className="formCol right">
                <span className="label">
                  Максимальное количество пассажиров:
                </span>
              </Col>
              <Col span={12} className="formCol">
                <PassengersCount
                  val={
                    request.passengersCount !== null
                      ? request.passengersCount
                      : "0"
                  }
                  decorator={getFieldDecorator}
                  classes="small mr"
                  disabled
                />
              </Col>
            </Row>
          )}
          <Divider />
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Адрес пункта подачи ТС:</span>
            </Col>
            <Col span={12} className="formCol">
              <StartPoint
                val={
                  request.routes && request.routes.length
                    ? request.routes[0].route
                    : "Не указано"
                }
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
            <Col span={6} className="formCol extra-label">
              <Button
                id="routeMap"
                block
                className="btn"
                onClick={
                  request.routes && request.routes.length
                    ? e => showDrawer(e)
                    : null
                }
              >
                Показать на карте
              </Button>
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Дата и время подачи ТС:</span>
            </Col>
            <Col span={12} className="formCol">
              <ArrivalDate
                val={
                  request.arrivalDatetime
                    ? moment(request.arrivalDatetime).format("DD.MM.YYYY")
                    : "Не указано"
                }
                decorator={getFieldDecorator}
                classes="short mr"
                disabled
              />
              <ArrivalTime
                val={
                  request.arrivalDatetime
                    ? moment(request.arrivalDatetime).format("HH:mm")
                    : ""
                }
                decorator={getFieldDecorator}
                classes="medium"
                disabled
              />
              {request.arrivalDatetime ? (
                <span className="fieldInfo">
                  {new moment(request.arrivalDatetime).fromNow()}
                  {request.routes.length > 0 &&
                  request.routes[0] &&
                  request.routes[0].duration
                    ? ` (Длительность посадки: ${moment
                        .duration(request.routes[0].duration)
                        .asMinutes()} мин)`
                    : ""}
                </span>
              ) : null}
            </Col>
            {request.routes && request.routes.length > 1 ? (
              <Col span={6} className="formCol extra-label">
                <Button
                  block
                  className="btn"
                  id="routeSchema"
                  onClick={
                    request.routes && request.routes.length
                      ? e => showDrawer(e)
                      : null
                  }
                >
                  График движения
                </Button>
              </Col>
            ) : null}
          </Row>

          {request.routes && request.routes.length
            ? this.renderMidPoints(request.routes)
            : null}

          <Row
            type="flex"
            align="middle"
            className="formRow withFieldInfo double-margin"
            gutter={16}
          >
            <Col span={6} className="formCol right">
              <span className="label">Конечный пункт маршрута:</span>
            </Col>
            <Col span={12} className="formCol">
              <EndPoint
                val={
                  request.routes && request.routes.length
                    ? request.routes[request.routes.length - 1].route
                    : "Не указан"
                }
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
              <span className="fieldInfo">
                {request.routes && request.routes.length > 1
                  ? EqualToStart(
                      request.routes[0].route,
                      request.routes[request.routes.length - 1].route
                    )
                  : null}
                {` (Длительность высадки: ${moment
                  .duration(
                    request.routes &&
                      request.routes.length > 0 &&
                      request.routes[request.routes.length - 1].duration
                  )
                  .asMinutes()} минут)`}
              </span>
            </Col>
          </Row>
          <Divider />
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Уровень обслуживания:</span>
            </Col>
            <Col span={12} className="formCol">
              <Maintenance
                val={
                  request.maintenanceLevels && request.maintenanceLevels.length
                    ? request.maintenanceLevels
                        .map(level => level.maintenanceLevel)
                        .join(", ")
                    : "Не указано"
                }
                decorator={getFieldDecorator}
                classes="short"
                disabled
              />
            </Col>
          </Row>
          {/*
          // Это раздел в форме заявки "заявленное время использования", код рабочий. Если не будет нужнен, код можно смело удалять
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">
                Заявленное время
                <br /> использования:
              </span>
            </Col>
            <Col span={12} className="formCol">
              <UsingTime
                val={request.usingTime ? request.usingTime : 'Не указано'}
                decorator={getFieldDecorator}
                classes="short"
                disabled
              />
            </Col>
          </Row>
          */}
          <Row type="flex" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Комментарий:</span>
            </Col>
            <Col span={12} className="formCol">
              <Comment
                val={request.comment}
                decorator={getFieldDecorator}
                classes="long"
                rows={6}
                disabled
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FastForm);
